import styled from '@emotion/styled'

import { HeadingS } from '@/components/Typography'

import { Agency, type AgencyItem } from './Agency'

export interface LocalsProps {
  id: string
  state: string
  locals: AgencyItem[]
}

const LocalsItemStyles = styled.div({
  display: 'flex',
  flexFlow: 'row wrap',
  justifyContent: 'flex-start',
  margin: '1rem -1rem 2rem',
})

const LocalsStyles = styled.div({
  '&:last-child': {
    marginRight: 'auto',
  },
})

export const Locals = ({ state, locals }: LocalsProps) => (
  <LocalsStyles>
    <HeadingS>{state}</HeadingS>
    {locals.map((agency, index) => (
      <LocalsItemStyles key={`${index}-${agency.id}`}>
        <Agency agency={agency} />
      </LocalsItemStyles>
    ))}
  </LocalsStyles>
)
